import React from 'react';

interface ButtonProps {
  type?: 'primary' | 'secondary';
  onClick?: () => void;
  disabled?: boolean;
  text?: string;
  className?: string;
  buttonType?: 'button' | 'submit' | 'reset';
  loading?: boolean;
  'data-testid'?: string;
}

const Button: React.FC<ButtonProps> = ({
  type = 'primary',
  onClick,
  disabled = false,
  text = 'Click Me',
  buttonType = 'button',
  loading = false,
  'data-testid': testId,
}) => {
  const buttonClass = `text-sm rounded-lg flex items-center justify-center py-[13.5px] w-full font-medium leading-[21px] h-12 cursor-pointer ${
    type === 'secondary'
      ? 'bg-[#E1EFFE] text-primary hover:bg-[#D7EAFF]'
      : 'bg-[#1C67F9] text-white disabled:bg-[#A0A0A0] disabled:cursor-not-allowed hover:bg-[#1C67F9]'
  }`;

  return (
    <button
      type={buttonType}
      className={buttonClass}
      onClick={onClick}
      disabled={disabled || loading} // Disable button when loading
      data-testid={testId}
    >
      {loading ? (
        <div className="loader h-5 w-5 animate-spin rounded-full border-4 border-solid border-white border-t-transparent"></div>
      ) : (
        text
      )}
    </button>
  );
};

export default Button;
